import { memo } from 'react';
import classes from './hr.module.scss';

export const Hr = memo(() => {
	return <hr className={classes.hr} style={{ color: '#DDDDDD' }} aria-hidden="true" />;
});
